import { render, staticRenderFns } from "./consultList.vue?vue&type=template&id=09b31f73&scoped=true"
import script from "./consultList.vue?vue&type=script&lang=js"
export * from "./consultList.vue?vue&type=script&lang=js"
import style0 from "./consultList.vue?vue&type=style&index=0&id=09b31f73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b31f73",
  null
  
)

export default component.exports